import { useEffect, useRef, memo } from 'react';
import { metrics } from 'bc-metrics';
import type { AuthAccountWithPassType } from 'bc-artifacts-client/api';

type Props = {
  user: AuthAccountWithPassType | null;
  viewName: string | null;
};

const MetricsConfig = memo(function MetricsBridge({ user, viewName }: Props) {
  const prevRef = useRef<Props>({
    user: null,
    viewName: null,
  });

  // Update when user changes
  useEffect(() => {
    if (user == null) return;
    if (prevRef.current.user?.id === user?.id) return;
    try {
      metrics.setUser(user);
    } catch (err) {
      console.error('Failed to set user in metrics:', err);
    }
    prevRef.current.user = user;
  }, [user]);

  // Update view name when it changes, but only if user is already set
  useEffect(() => {
    if (!viewName) return;
    if (!prevRef?.current?.user) return;
    if (prevRef.current.viewName === viewName) return;
    try {
      metrics.setViewName(viewName);
    } catch (err) {
      console.error('Failed to set view name in metrics:', err);
    }
    prevRef.current.viewName = viewName;
  }, [viewName]);

  return null;
});

export default MetricsConfig;
